import React from 'react';
import scaleSize from '../../utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(62)}
    height={scaleSize(40)}
    viewBox="0 0 62 40"
  >
    <g fill="#FFF" fillRule="evenodd">
      <path d="M58.92.325L30.904 18.317a2 2 0 0 0 0 3.366l28.014 17.991A2 2 0 0 0 62 37.992V2.008A2 2 0 0 0 58.92.325z" />
      <path d="M28.92.325L.904 18.317a2 2 0 0 0 0 3.366l28.014 17.991A2 2 0 0 0 32 37.992V2.008A2 2 0 0 0 28.92.325z" />
    </g>
  </svg>
);
